import { createSlice } from "@reduxjs/toolkit";
import { CredentialConfigModel } from "../../data-model/credentialConfigModel";
import { FirestoreService } from "../../../shared/api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../shared/api/firebase/references";
import { AppDispatch } from "../store/store";

export interface CredentialDetailsState {
  data: CredentialConfigModel | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: CredentialDetailsState = {
  data: null,
  isLoading: false,
  error: null,
};

export const credentialDetailsSlice = createSlice({
  name: "credentialDetails",
  initialState,
  reducers: {
    setCredentialDetails: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setCredentialDetails, setIsLoading, setError } =
  credentialDetailsSlice.actions;

export const fetchCredentialDetails =
  (credentialId: string) => async (dispatch: AppDispatch) => {
    dispatch(setIsLoading(true));
    try {
      const credential =
        await FirestoreService.getDocument<CredentialConfigModel>(
          FirestoreDocumentReference.credentialDetails(credentialId),
        );
      dispatch(setCredentialDetails(credential));
    } catch (error) {
      dispatch(setError(error as string));
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export default credentialDetailsSlice.reducer;
